/**
 * Navigates to the last page and scrolls to the bottom of the DataGridPro
 * so the newly added row is visible to the user.
 * Uses timeouts to let the grid re-render before navigating.
 *
 * @param {Object} apiRef    - DataGridPro apiRef from useGridApiRef()
 * @param {number} totalRows - Total row count after adding the new row
 */
export const scrollToNewRow = (apiRef, totalRows) => {
  setTimeout(() => {
    if (apiRef.current) {
      const pageSize = apiRef.current.state.pagination.paginationModel.pageSize;
      const lastPage = Math.max(0, Math.ceil(totalRows / pageSize) - 1);
      apiRef.current.setPage(lastPage);
      setTimeout(() => {
        apiRef.current.scrollToIndexes({ rowIndex: totalRows - 1 });
      }, 50);
    }
  }, 100);
};
